
//gets query params for debugging
//not for production use since it won't work perfectly on IE for encoded params
export function getDebugQueryParam(queryParamName){
    if(!window.URLSearchParams){
        return findGetParameter(queryParamName);
    }
    return new URLSearchParams(window.location.search).get(queryParamName);
}

//https://stackoverflow.com/questions/5448545/how-to-retrieve-get-parameters-from-javascript
function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    var items = location.search.substr(1).split("&");
    for (var index = 0; index < items.length; index++) {
        tmp = items[index].split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    }
    return result;
}